<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="admin_users"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class AdminUserDetail extends Vue {
  data = {}

  get columns() {
    return [
      ...createColumns.call(this),
      {
        prop: 'action',
        label: '操作',
        edit: true,
        delete: {
          handler: this.handleDelete
        }
      }
    ]
  }

  async mounted() {
    this.data = await this.$request.get(`/admin_users/${this.$route.params.id}`);
  }

  async handleDelete({ row }) {
    await this.$autoLoading(this.$request.delete(`/admin_users/${row.id}`));
    this.$message.success('删除管理员成功');
    this.$router.replace({ name: 'admin_users.index' });
  }
}
</script>
